import { Component } from "react"

/* Constants */
import { env } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"




/* Widget Preloader */
class Preloader extends Component {

    render = () => {

        const { url } = this.props

        const gameImg = url ? url : "https://cb.cuba-lv.com/images/table-images/game-1768978738541-back.jpeg"//`${env.mediapoint}/images/back-casino.webp`

        return (
            <div className="preloader">
                <Picture className="full-image" src={gameImg} alt="Background" />
                <div className="preloader-logo">
                    <Picture src={`preloader.png`} alt="Preloader" />
                </div>
                <div className="preloader-indicator">
                    <Picture className="line" src={`${env.mediapoint}/images/preloader/preloader.svg`} alt="Preloader" />
                    <Picture className="star" src={`${env.mediapoint}/images/preloader/star.svg`} alt="Preloader" />
                </div>
                <p className="support">При поддержке</p>
                <Picture className="cubago" src={`${env.mediapoint}/images/cubago.png`} alt="Preloader" />
            </div>
        )
    }

}

export default Preloader